import type { IframeBlockConfig } from '@lighthouse/core'

export const generateIframeBlock = (mainBreakPoint: string): IframeBlockConfig => {
    return {
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 300,
                    unit: 'px'
                },
                overflow: 'visible'
            },
            layout: {}
        },
        breakPoints: []
    }
}
